import type { AttachToConfig, CanvasJSONLikeObject, TextStyleRule } from '@doer/frontend-components/creativity-editor';
import { TEXT_DEFAULTS } from './text-defaults';

export interface AutoFitTextOpts {
  pieceId: string;
  text: string;
  fontSize: number;
  fill: string;
  position: { left: number; top: number; width: number; height: number };

  fontWeight?: number | 'normal' | 'bold';
  lineHeight?: number;
  textAlign?: 'left' | 'center' | 'right';
  originY?: 'top' | 'center' | 'bottom';
  locked?: boolean;

  minFontSize?: number;
  autoFitMaxHeight?: number;
  autoFitMaxWidth?: number;

  textStyleRules?: TextStyleRule[];
  attachTo?: AttachToConfig;
  scaleX?: number;
  scaleY?: number;
  linkedAcrossResolutions?: boolean;
  objectCaching?: boolean;
}

export function buildAutoFitText(opts: AutoFitTextOpts): CanvasJSONLikeObject {
  const { pieceId, text, fontSize, fill, position } = opts;
  const fontWeight = opts.fontWeight ?? 400;
  const lineHeight = opts.lineHeight ?? 1.16;
  const textAlign = opts.textAlign ?? 'center';
  const originY = opts.originY ?? 'top';
  const locked = opts.locked ?? true;
  const objectCaching = opts.objectCaching ?? false;
  const minFontSize = opts.minFontSize ?? fontSize;
  const autoFitMaxHeight = opts.autoFitMaxHeight ?? position.height;
  const width = opts.autoFitMaxWidth ?? position.width;

  return {
    ...TEXT_DEFAULTS,
    type: 'Textbox',
    pieceId,
    text,
    fontSize,
    fontWeight,
    lineHeight,
    textAlign,
    originY,
    left: position.left,
    top: position.top,
    width,
    height: position.height,
    scaleX: opts.scaleX ?? 1,
    scaleY: opts.scaleY ?? 1,
    fill,
    objectCaching,
    lockScalingX: locked,
    lockScalingY: locked,
    lockRotation: locked,
    autoFit: {
      minFontSize,
      maxFontSize: fontSize,
      maxHeight: autoFitMaxHeight,
      snapTo: 2
    },
    ...(opts.textStyleRules ? { textStyleRules: opts.textStyleRules } : {}),
    ...(opts.attachTo ? { attachTo: opts.attachTo } : {}),
    ...(opts.linkedAcrossResolutions !== undefined ? { linkedAcrossResolutions: opts.linkedAcrossResolutions } : {})
  };
}
